<template>
  <div class="weui-search-bar" :class="[inputShow ? 'weui-search-bar_focusing' : '']">
    <div class="weui-search-bar__form">
      <div class="weui-search-bar__box">
        <i class="weui-icon-search iconfont icon-search95a1aaac44fdb4"></i>
        <input
          ref="_input"
          type="search"
          class="weui-search-bar__input"
          placeholder="搜索"
          required=""
          v-model="inputValue"
          @blur="inputBlur"
          @keyup.enter="submitSearch">
        <a
          v-if="inputValue.length > 0"
          href="javascript:;"
          class="weui-icon-clear iconfont icon-icon_wrong"
          @click="clearInputValue">
        </a>
      </div>
      <label
        class="weui-search-bar__label"
        @click="showSearchInput">
          <i class="weui-icon-search iconfont icon-search95a1aaac44fdb4"></i>
          <span>搜索</span>
      </label>
    </div>
    <a href="javascript:;" class="weui-search-bar__cancel-btn" @click="cancelBtn">取消</a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      inputShow: false,
      inputValue: ''
    }
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showSearchInput () {
      this.inputShow = true
      this.$refs._input.focus()
      this.$emit('onClick')
    },
    clearInputValue () {
      this.inputValue = ''
      this.$nextTick(() => {
        this.$refs._input.focus()
      })
      this.$emit('onClearValue')
    },
    cancelBtn () {
      this.inputShow = false
      this.inputValue = ''
      this.$emit('onCancel')
    },
    inputBlur () {
      this.$emit('onBlur')
    },
    submitSearch () {
      this.$emit('submitSearch', this.inputValue)
    }
  },
  watch: {
    isShow () {
      this.inputShow = this.isShow
    }
  }
}
</script>

<style scoped>
  input::-webkit-search-cancel-button{
    display: none;
  }
  input[type=search]::-ms-clear{
    display: none;
  }
  .weui-search-bar {
    position: relative;
    padding: 8px 10px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    background-color: #efeff4;
  }
  .weui-search-bar:after, .weui-search-bar:before {
    content: " ";
    position: absolute;
    left: 0;
    right: 0;
    height: 1px;
    color: #d7d6dc;
  }
  .weui-search-bar__form {
    position: relative;
    -webkit-box-flex: 1;
    -webkit-flex: auto;
    flex: auto;
    background-color: #efeff4;
  }
  .weui-search-bar__box {
    position: relative;
    padding-left: 30px;
    padding-right: 30px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    z-index: 1;
  }
  .weui-icon-clear, .weui-icon-search {
    color: #b2b2b2;
    font-size: 14px;
    vertical-align: sub;
  }
  .weui-search-bar__box .weui-icon-search {
    position: absolute;
    left: 10px;
    top: 0;
    line-height: 28px;
  }
  .weui-search-bar__box .weui-search-bar__input {
    padding: 4px 0;
    width: 100%;
    height: 1.42857143em;
    border: 0;
    font-size: 14px;
    line-height: 1.42857143em;
    box-sizing: content-box;
    background: transparent;
  }
  .weui-search-bar__box .weui-icon-clear {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 10px;
    line-height: 28px;
  }
  .weui-search-bar__label {
    position: absolute;
    top: 1px;
    right: 1px;
    bottom: 1px;
    left: 1px;
    z-index: 2;
    border-radius: 3px;
    text-align: center;
    color: #9b9b9b;
    background: #fff;
  }
  .weui-search-bar__label .weui-icon-search {
    margin-right: 5px;
  }
  .weui-search-bar__label span {
    display: inline-block;
    font-size: 14px;
    vertical-align: sub;
  }
  .weui-search-bar__form:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 200%;
    height: 200%;
    -webkit-transform: scale(.5);
    transform: scale(.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    border-radius: 10px;
    border: 1px solid #e6e6ea;
    box-sizing: border-box;
    background: #fff;
  }
  .weui-search-bar__cancel-btn {
    display: none;
    margin-left: 10px;
    line-height: 28px;
    color: #26a2ff;
    white-space: nowrap;
  }
  .weui-search-bar:after, .weui-search-bar:before {
    content: " ";
    position: absolute;
    left: 0;
    right: 0;
    height: 1px;
    color: #d7d6dc;
  }
  .weui-search-bar:after {
    bottom: 0;
    border-bottom: 1px solid #d7d6dc;
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }
  .weui-search-bar_focusing .weui-search-bar__cancel-btn{display:block}
  .weui-search-bar_focusing .weui-search-bar__label{display:none}
</style>
